import { createContext, useContext, useState, useEffect } from "react";

type AuthContextType = {
  executeSignIn: boolean;
  setExecuteSignIn: (value: boolean) => void;
};

export const AuthContext = createContext<AuthContextType | null>(null);

let setExecuteSignInGlobal: ((value: boolean) => void) | null = null;

export const triggerSignIn = (value: boolean) => {
  if (setExecuteSignInGlobal) {
    setExecuteSignInGlobal(value);
  }
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [executeSignIn, setExecuteSignIn] = useState(false);

  useEffect(() => {
    setExecuteSignInGlobal = setExecuteSignIn;
  }, []);

  return (
    <AuthContext.Provider value={{ executeSignIn, setExecuteSignIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext deve ser usado dentro de um AuthProvider");
  }
  return context;
};
